export default __webpack_public_path__ + "static/media/mobile_trees.d39fd696.svg";